var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.27 9.083h-.625l-.221-.213a5.123 5.123 0 001.243-3.35 5.146 5.146 0 10-5.146 5.147A5.123 5.123 0 008.87 9.424l.213.221v.626l3.959 3.95 1.18-1.18-3.951-3.958zm-4.75 0a3.558 3.558 0 01-3.562-3.562 3.558 3.558 0 013.563-3.563 3.558 3.558 0 013.562 3.563 3.558 3.558 0 01-3.562 3.562z",
    fill: "#0073B1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h19v19H-2z"
  }))));
}
export default __webpack_public_path__ + "img/324f8a336e32c9b30e233d181f9d1707.svg";
export { SvgSearch as ReactComponent };